import { TextField, MenuItem } from '@mui/material';
import { GENDERS } from '../../constants/userConstants';

interface GenderFieldProps {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  helperText?: string;
  label?: string;
}

export default function GenderField({
  value,
  onChange,
  required = false,
  disabled = false,
  fullWidth = true,
  helperText,
  label = 'Gender',
}: GenderFieldProps) {
  return (
    <TextField
      fullWidth={fullWidth}
      select
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      required={required}
      disabled={disabled}
      helperText={helperText}
    >
      <MenuItem value="">
        <em>Not specified</em>
      </MenuItem>
      {GENDERS.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
